import script from "./sop-knowledge.vue?vue&type=script&lang=js&setup=true"
export * from "./sop-knowledge.vue?vue&type=script&lang=js&setup=true"

import "./sop-knowledge.vue?vue&type=style&index=0&id=7f574d95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f574d95"]])

export default __exports__